<div class="dialog-container-main ">
    <div class="dialog-header">
        <h2 mat-dialog-title >
            
        </h2><button mat-button mat-dialog-close><span class="material-icons">close</span></button>
    </div>
    <form>
        <mat-dialog-content class="mat-typography">
            <div class="dialog-form-box">

                <div class="resume-content">
                    <div class="alert-icon margin-bottom2">
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7942 0.750041L19.5264 15.875C19.6068 16.0144 19.6492 16.1725 19.6492 16.3334C19.6492 16.4943 19.6068 16.6523 19.5264 16.7917C19.4459 16.931 19.3302 17.0468 19.1909 17.1272C19.0515 17.2077 18.8934 17.25 18.7325 17.25H1.26821C1.1073 17.25 0.949228 17.2077 0.809881 17.1272C0.670533 17.0468 0.554818 16.931 0.474367 16.7917C0.393915 16.6523 0.351561 16.4943 0.351563 16.3334C0.351564 16.1725 0.393919 16.0144 0.474373 15.875L9.20654 0.750041C9.287 0.610701 9.40271 0.494993 9.54206 0.414546C9.68141 0.334099 9.83947 0.291748 10.0004 0.291748C10.1613 0.291748 10.3193 0.334099 10.4587 0.414546C10.598 0.494993 10.7137 0.610701 10.7942 0.750041ZM2.85587 15.4167H17.1449L10.0004 3.04171L2.85587 15.4167ZM9.0837 12.6667H10.917V14.5H9.0837V12.6667ZM9.0837 6.25004H10.917V10.8334H9.0837V6.25004Z" fill="#FB3333"/>
                        </svg>
                            
                    </div>

                    <mat-label class="labelsuper18 margin-bottom2">Please confirm!</mat-label>
                    <mat-label *ngIf="debtHeader==false" class="labelsuper-normal400 text-center margin-bottom2 ">Do you want to resume, <b>{{currentApplicationName}}</b> application.</mat-label>
                    <mat-label  *ngIf="debtHeader==true" class="labelsuper-normal400 text-center margin-bottom2 ">You have an existing application <b>({{currentApplicationName}})</b> in progress. Would you like to Resume or Start New Application. If you start a new application, the old application will be closed. </mat-label>

                    <mat-dialog-actions class="btn-col-footer">
                        <button  (click)="closepopup('new')" mat-button color="primary" mat-dialog-close> Start New</button>
                        <button (click)="closepopup('resume')" mat-button  cdkFocusInitial class="new-btn">
                            Resume
                          </button>
                      </mat-dialog-actions>

                </div>



            </div>

        </mat-dialog-content>

    </form>
</div>